import * as React from "react";

export type CollabSpinnerProps = {
  size?: "sm" | "md";
  label?: string;
  className?: string;
};

/** CSS-only loading spinner — replaces antd Spin in collaborate. */
export const CollabSpinner: React.FC<CollabSpinnerProps> = ({
  size = "md",
  label = "Loading",
  className,
}) => (
  <span
    className={`collab-spinner collab-spinner--${size}${className ? ` ${className}` : ""}`}
    role="status"
    aria-label={label}
  />
);

export default CollabSpinner;
